import LowInventoryBadge from "../LowInventoryBadge/LowInventoryBadge.web";
import RemainingInventoryBadge from "../RemainingInventoryBadge/RemainingInventoryBadge.web";
import { useInventoryBadge } from "./useInventoryBadge";
import { InventoryBadgeProps } from "./InventoryBadge.props";

const InventoryBadge = (props: InventoryBadgeProps) => {
  const { lowInventoryBadgeProps, className } = props;
  const {
    showLowInventory,
    showRemainingTickets,
    numOfRemainingTickets,
    lowTicketInventory,
    lowThreshold,
    middleThreshold,
    highThreshold,
  } = useInventoryBadge(props);

  return (
    <>
      {/* RemainingInventoryBadge takes precedence over LowInventoryBadge */}
      {showLowInventory && !showRemainingTickets && (
        <LowInventoryBadge
          level={lowTicketInventory}
          highThreshold={Number(highThreshold)}
          middleThreshold={Number(middleThreshold)}
          lowThreshold={Number(lowThreshold)}
          className={className}
          {...lowInventoryBadgeProps}
        />
      )}
      {showRemainingTickets && (
        <RemainingInventoryBadge
          className={className}
          remainingTickets={Number(numOfRemainingTickets)}
        />
      )}
    </>
  );
};

export default InventoryBadge;
